<!--
  [暫定]ツアー0件の場合history back対応のために作成
  対応終了後に削除すること
-->
<template>
  <div class="tourNotExistCassette">
    <span class="tourNotExistCassette_linkText">
      該当するツアーが見つかりませんでした<br>
      違う検索条件でお試しください
    </span>
    <div class="tourNotExistCassette_imageArea">
      <tk-image
        class="tourNotExistCassette_image"
        :image-path="require('@ota-frontend/shared-assets/images/tour/concierge.jpg')"
        alt="オーダーメイド"
      />
    </div>
    <div class="tourNotExistCassette_wrap">
      <div class="tourNotExistCassette_btn">
        <tk-left-arrow-button
          class="-red"
          @click="backPage"
        >
          戻る
        </tk-left-arrow-button>
      </div>
      <div class="tourNotExistCassette_area">
        <a href="/area/" class="tourNotExistCassette_area_linkText">取り扱いエリア一覧へ<i></i></a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  TkImage,
  TkLeftArrowButton,
} from '@ota-frontend/ui'

export default {
  name: 'TourNotExistCassette',
  components: {
    TkImage,
    TkLeftArrowButton,
  },
  methods: {
    backPage () {
      history.back()
    },
  },
}
</script>

<style scoped lang="scss">
.tourNotExistCassette {
  font-size: 11px;
  border-top: 0;
  border: 0;
  color: #333;
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px 0px;
  padding: 10px 10px 25px 10px;
  box-sizing: border-box;
  border-radius: 12px;
  font-family: "ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","メイリオ",Meiryo,"ＭＳ Ｐゴシック","MS PGothic",Osaka,sans-serif;
  min-width: 320px;
}

.tourNotExistCassette_linkText {
  text-decoration: underline;
  font-size: 15px;
  font-weight: bold;
  line-height: 22px;
}

.tourNotExistCassette_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tourNotExistCassette_imageArea {
  margin: 15px;
  text-align: center;
}

.tourNotExistCassette_btn {
  width: 48%;
  margin-top: 20px;
  background-color: #F9423A;
  box-shadow: #c5130b 0px 4px;
  border-radius: 4px;
  padding: 0px 10px 0px 0px;
}

.tourNotExistCassette_area{
  width: 48%;
  text-align: center;
  margin-top: 20px;
  background-color: #F9423A;
  box-shadow: #c5130b 0px 4px;
  border-radius: 4px;
  padding: 0px 10px 0px 0px;
}
.tourNotExistCassette_area_linkText{
  position: relative;
  display: block;
  padding: 10px 12px;
  font-size: 14px;
  color: #fff;
}
.tourNotExistCassette_area_linkText:hover{
  text-decoration: none;
}
.tourNotExistCassette_area_linkText i{
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.tourNotExistCassette_area_linkText i:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  content: "";
  vertical-align: middle;
}
.tourNotExistCassette_area_linkText i::after {
  border-right: 2px solid;
  border-top: 2px solid;
  height: 5px;
  width: 5px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 3px;
  margin: auto;
  content: "";
  vertical-align: middle;
  transform: rotate(44deg);
}
</style>
